import React from 'react'

export default function Stairs({ className }) {
    return (
        <svg
            className={`${className} w-8 h-8`}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2 22V17H7V12H12V7H17V2H22V22H2Z"
                fill="#0EA5E9"
            />
            <path
                d="M2 22V17H7V12H12V7H17V2"
                stroke="#0369A1"
                strokeWidth="1.2"
                strokeLinejoin="round"
                strokeLinecap="round"
            />
        </svg>
    )
}
